import { render, staticRenderFns } from "./TableDesigner.vue?vue&type=template&id=497c31ae"
import script from "./TableDesigner.vue?vue&type=script&lang=js"
export * from "./TableDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports